import React, { useEffect, useState } from 'react';
import 'react-table-v6/react-table.css';
import Sidebar from '../../commonAdmin/Sidebar';
import Header from '../../commonAdmin/Header';
import { Col, Container, Row } from 'react-bootstrap';
import {
  useHistory,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
import delivaApiService from '../../../../common/services/apiService';
import { showErrorToast } from '../../../../common/helpers/Utils';
import Loader from '../../../common/Loader';
import moment from 'moment';

const PromoDetails = (props) => {
  const [showLoader, setShowLoader] = React.useState(false);
  const [promoDetail, setPromoDetail] = React.useState(null);
  const [loading, setLoading] = useState(false);

  // hooks
  const history = useHistory();

  //
  const { id } = useParams();
  console.log('path id', id);

  const convertToLocalDate = (dateString) => {
    if (!dateString) return '--';
    return moment.utc(dateString).local().format('DD MMM YYYY');
  };

  // Your existing time converter function is fine:
  const convertTo12HourTime = (time24) => {
    if (!time24) return '--';

    const [hour, minute] = time24.split(':');
    const utcDate = new Date(
      Date.UTC(1970, 0, 1, parseInt(hour), parseInt(minute))
    );

    return utcDate.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };

  const getPromoDetails = (id) => {
    setShowLoader(true);
    delivaApiService('getPromo', { promoId: id })
      .then((response) => {
        setShowLoader(false);
        if (response?.data?.status === 200) {
          const data = response?.data?.resourceData;
          setPromoDetail(data);
          console.log(data, 'data....');
        } else if (response?.data?.status === 400) {
          showErrorToast(response?.data?.message);
        }
      })
      .catch((error) => {
        setShowLoader(false);
        console.error('Failed to update status:', error);
      });
  };

  useEffect(() => {
    if (id) {
      setPromoDetail(null);
      setShowLoader(true);
      getPromoDetails(id);
    }
  }, [id]);

  return (
    <div className="page__wrapper h-100">
      <Header {...props} />
      <div className="mainContainer CustomerTable">
        <Row noGutters className="h-100">
          <Sidebar {...props} />
          <Col md={9} lg={10} className="boxTyp3">
            <Container fluid>
              <div className="content-wrapper">
                <section className="page-header mb-4">
                  <div className="w-100">
                    <h3 className="font-weight-normal mb-0 line-ht color-33 fs-24">
                      Promo Details
                    </h3>
                    <h5 className="font-weight-normal mb-0 line-ht color-head">
                      <span
                        className="pointer"
                        onClick={() =>
                          history.push({
                            pathname: `/promotionReferralList`,
                            state: {
                              tab: 'promotion',
                            },
                          })
                        }
                      >
                        Promotion & Referral
                      </span>
                      <span className="icon-next mx-2 fs12"></span>
                      <span className="pointer">Promo Details </span>
                    </h5>
                  </div>
                </section>
                <section className="details-wrap mb-4">
                  <Row noGutters>
                    <Col md={12} lg={12}>
                      {showLoader || !promoDetail ? (
                        <div style={{ minHeight: 100 }}>
                          <Loader showLoader={true} />
                        </div>
                      ) : (
                        <>
                          <h5 className="px-4">
                            {promoDetail?.userType === 'delivery_agent'
                              ? 'Delivery Partner'
                              : 'Sender'}
                          </h5>
                          <hr />
                        </>
                      )}
                    </Col>
                  </Row>
                  {!showLoader && promoDetail && (
                    <>
                      <Row className="px-4">
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Offer Type
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {promoDetail?.offerType
                              ? promoDetail?.offerType
                              : '--'}
                          </p>
                        </Col>
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Delivery Type
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {promoDetail?.deliveryRequestType ===
                            'LOCAL_DELIVERY'
                              ? 'Local Delivery'
                              : '--'}
                          </p>
                        </Col>
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Sender Type
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {promoDetail?.userCategory ===
                            'EXISTING_ON_BOARDING'
                              ? 'Existing Onboarding'
                              : promoDetail?.userCategory === 'NEW_ON_BOARDING'
                              ? 'New Onboarding'
                              : '--'}
                          </p>
                        </Col>
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Name of Offer
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {promoDetail?.offerName
                              ? promoDetail?.offerName
                              : '--'}
                          </p>
                        </Col>

                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Discount Type
                          </h5>

                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {promoDetail?.promoDiscountType === 'FREE_DELIVERY'
                              ? 'Free delivery'
                              : promoDetail?.promoDiscountType ===
                                'FIXED_AMOUNT'
                              ? 'Fixed Amount'
                              : promoDetail?.promoDiscountType ===
                                'PERCENTAGE_DISCOUNT'
                              ? 'Percentage discount '
                              : '--'}
                          </p>
                        </Col>
                        {promoDetail?.userType !== 'delivery_agent' && (
                          <Col md={6} lg={3} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Discount percentage
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {promoDetail?.percentageDiscount
                                ? promoDetail?.percentageDiscount
                                : 0}
                              %
                            </p>
                          </Col>
                        )}
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            {promoDetail?.userType === 'delivery_agent'
                              ? 'Reward Amount'
                              : 'Max Amount of Discount(upto)'}
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            ₦
                            {promoDetail?.maxDiscountAmount
                              ? promoDetail?.maxDiscountAmount
                              : 0}
                          </p>
                        </Col>
                        {promoDetail?.userType === 'delivery_agent' && (
                          <>
                            <Col md={6} lg={3} className="mb-4">
                              <h5 className="font-weight-normal color-grey fs18">
                                No. of Delivery
                              </h5>
                              <p className="fs18 font-weight-500 mb-0 gray-600">
                                {promoDetail?.noOfDelivery
                                  ? promoDetail?.noOfDelivery
                                  : 0}
                              </p>
                            </Col>
                            <Col md={6} lg={3} className="mb-4">
                              <h5 className="font-weight-normal color-grey fs18">
                                Delivery Duration
                              </h5>
                              <p className="fs18 font-weight-500 mb-0 gray-600">
                                {promoDetail?.deliveryDuration
                                  ? `${promoDetail?.deliveryDuration} ${
                                      promoDetail?.deliveryDurationUnit ===
                                      'WEEK'
                                        ? 'Week'
                                        : 'Days'
                                    }`
                                  : 0}
                              </p>
                            </Col>
                          </>
                        )}
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Country
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {promoDetail?.region ? promoDetail?.region : '--'}
                          </p>
                        </Col>
                        <Col md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Currency
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {promoDetail?.currency
                              ? promoDetail?.currency
                              : '--'}{' '}
                          </p>
                        </Col>
                        <Col md={12} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Description
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {promoDetail?.description
                              ? promoDetail?.description
                              : '--'}
                          </p>
                        </Col>
                        <Col md={12} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Promo Details
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {promoDetail?.details ? promoDetail?.details : '--'}
                          </p>
                        </Col>
                        <Col md={12} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            How to Redeem
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {promoDetail?.redeem ? promoDetail?.redeem : '--'}
                          </p>
                        </Col>
                        <Col md={12} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Discount Application
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {promoDetail?.discountApplicationType ===
                            'MANUAl_ENTRY'
                              ? 'Manual Entry'
                              : 'Automatic Application'}
                          </p>
                        </Col>
                        <Col md={6} lg={4} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Code
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {promoDetail?.code ? promoDetail?.code : '--'}
                          </p>
                        </Col>
                        <Col md={6} lg={4} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Usage frequency
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {promoDetail?.usageFrequency === 'ONE_TIME_USE'
                              ? 'One time use'
                              : promoDetail?.usageFrequency === 'ONCE_FIVE_DAYS'
                              ? 'Once every 5 days'
                              : promoDetail?.usageFrequency === 'ONCE_A_WEEK'
                              ? 'Once a week'
                              : promoDetail?.usageFrequency === 'EVERY_TIME'
                              ? 'Every time'
                              : '--'}
                          </p>
                        </Col>
                      </Row>
                      <div className="mt-4 px-4">
                        <h3 className="font-weight-normal mb-3 line-ht color-33 fs20">
                          Discount Restrictions
                        </h3>
                        <Row>
                          <Col md={6} lg={4} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Minimum Order Amount
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {promoDetail?.minimumOrderAmount
                                ? promoDetail?.minimumOrderAmount
                                : '--'}
                            </p>
                          </Col>
                          <Col md={6} lg={4} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Usage Limits
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {promoDetail?.usageLimits === 'PER_SENDER'
                                ? 'Per sender'
                                : promoDetail?.usageLimits === 'OVERALL'
                                ? 'Overall'
                                : '--'}
                            </p>
                          </Col>
                          <Col md={6} lg={4} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Count of Usage Limits
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {promoDetail?.countOfUsageLimits
                                ? promoDetail?.countOfUsageLimits
                                : '--'}
                            </p>
                          </Col>
                        </Row>
                      </div>
                      <div className="mt-4 px-4">
                        <h3 className="font-weight-normal mb-3 line-ht color-33 fs20">
                          Promotion Dates and Time
                        </h3>
                        <Row>
                          <Col md={6} lg={3} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Start date
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {promoDetail?.promotionStartDate
                                ? convertToLocalDate(
                                    promoDetail?.promotionStartDate
                                  )
                                : '--'}
                            </p>
                          </Col>
                          <Col md={6} lg={3} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              End date
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {promoDetail?.promotionEndDate
                                ? convertToLocalDate(
                                    promoDetail?.promotionEndDate
                                  )
                                : 'Ongoing'}
                            </p>
                          </Col>
                          <Col md={6} lg={3} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Start time
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {promoDetail?.promotionStartTime
                                ? convertTo12HourTime(
                                    promoDetail?.promotionStartTime
                                  )
                                : '--'}
                            </p>
                          </Col>
                          <Col md={6} lg={3} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              End time
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {promoDetail?.promotionEndTime
                                ? convertTo12HourTime(
                                    promoDetail?.promotionEndTime
                                  )
                                : '--'}
                            </p>
                          </Col>
                          <Col md={6} lg={3} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Recurring Promotions
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              <p className="fs18 font-weight-500 mb-0 gray-600">
                                {promoDetail?.recurringPromotions ===
                                'EVERY_WEEKEND'
                                  ? 'Every weekend'
                                  : promoDetail?.recurringPromotions ===
                                    'MONTHLY'
                                  ? 'Monthly'
                                  : '--'}
                              </p>
                            </p>
                          </Col>
                        </Row>
                      </div>
                      <div className="mt-4 px-4">
                        <h3 className="font-weight-normal mb-3 line-ht color-33 fs20">
                          Special Conditions
                        </h3>
                        <Row>
                          <Col md={6} lg={4} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Geolocation-Based Promotions
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {promoDetail?.geolocationBasedPromotions
                                ? promoDetail?.geolocationBasedPromotions
                                : '--'}
                            </p>
                          </Col>
                          <Col md={6} lg={4} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Occasions
                            </h5>

                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {promoDetail?.occasions === 'BLACK_FRIDAY'
                                ? 'Black Friday'
                                : promoDetail?.occasions === 'CHRISTMAS'
                                ? 'Christmas'
                                : promoDetail?.occasions === 'OTHER'
                                ? 'Other'
                                : '--'}
                            </p>
                          </Col>
                          {promoDetail?.occasions === 'OTHER' && (
                            <Col md={6} lg={4} className="mb-4">
                              <h5 className="font-weight-normal color-grey fs18">
                                Please enter other occasions name
                              </h5>
                              <p className="fs18 font-weight-500 mb-0 gray-600">
                                {promoDetail?.otherOccasions
                                  ? promoDetail?.otherOccasions
                                  : '--'}
                              </p>
                            </Col>
                          )}
                        </Row>
                      </div>
                    </>
                  )}
                </section>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PromoDetails;
